// extracted by css-extract-rspack-plugin
export default {"cls1":"NewsHeader-cls1_PP2","cls2":"NewsHeader-cls2_2Xm NewsHeader-cls1_PP2"};